export default "__VITE_ASSET__DvdISBsf__"